import { Pipe, PipeTransform } from '@angular/core';
import { GlobalDataService } from '../services/globalData.service';

@Pipe({
  name: 'ConvertToUTCTime',
  pure: true, // Set to false if the timezone can change dynamically

})
export class ConvertToUTCTimePipe implements PipeTransform {

    constructor(private globalDataService: GlobalDataService) {}
  
 
  transform(value: string | Date): string {
    //
    if (!value) return "";
  
    let localDate: Date;
  
    if (typeof value === "string") {
      localDate = new Date(value);
    } else {
      localDate = value;
    }
  
    const timezoneOffset = this.globalDataService.getTimeZoneOffset(); // Get "+05:00" from token
    const parsedOffset = this.parseTimezoneOffset(timezoneOffset);
    if (isNaN(parsedOffset)) return "Invalid Date";
  
    // ✅ Convert local time to UTC by subtracting the offset
    const utcDate = new Date(localDate.getTime() - parsedOffset * 60000);
  
    return utcDate.toISOString(); // ✅ Returns the ISO format in UTC (with 'Z' at the end)
  }


  private parseTimezoneOffset(offset: string): number {
    const match = offset.match(/^([+-])(\d{2}):(\d{2})$/);
    if (!match) return NaN;

    const sign = match[1] === "+" ? 1 : -1;
    const hours = parseInt(match[2], 10);
    const minutes = parseInt(match[3], 10);

    return sign * (hours * 60 + minutes);
  }

}
